class FAQNavigation {
  constructor(section) {
    this.section = section;
    this.navItems = this.section.querySelectorAll('.section-faq-navigation__nav-item');
    this.categories = this.section.querySelectorAll('.section-faq-navigation__category');
    this.faqItems = this.section.querySelectorAll('.section-faq-navigation__item');
    this.progressBar = this.section.querySelector('.section-faq-navigation__progress-bar');
    this.nav = this.section.querySelector('.section-faq-navigation__nav');

    this.init();
  }

  init() {
    // Navigation click handlers
    this.navItems.forEach((navItem) => {
      navItem.addEventListener('click', (e) => {
        e.preventDefault();
        const categoryId = navItem.getAttribute('data-category-id');
        this.handleNavClick(categoryId, navItem);
      });
    });

    // FAQ accordion handlers
    this.faqItems.forEach((item) => {
      const question = item.querySelector('.section-faq-navigation__question');
      if (question) {
        question.addEventListener('click', () => {
          this.toggleFAQ(item);
        });
      }
    });

    // Mobile scroll progress
    if (this.nav && window.innerWidth < 990) {
      this.initMobileScroll();
    }

    // Intersection Observer for active state
    this.initIntersectionObserver();
  }

  handleNavClick(categoryId, clickedNavItem) {
    // Update active state
    this.navItems.forEach((item) => {
      item.classList.remove('section-faq-navigation__nav-item--active');
    });
    clickedNavItem.classList.add('section-faq-navigation__nav-item--active');

    // Scroll to category
    const targetCategory = this.section.querySelector(`#${categoryId}`);
    if (targetCategory) {
      const offset = window.innerWidth < 990 ? 100 : 150;
      const targetPosition = targetCategory.getBoundingClientRect().top + window.pageYOffset - offset;

      window.scrollTo({
        top: targetPosition,
        behavior: 'smooth'
      });
    }
  }

  toggleFAQ(item) {
    const isActive = item.classList.contains('section-faq-navigation__item--active');

    if (isActive) {
      item.classList.remove('section-faq-navigation__item--active');
    } else {
      item.classList.add('section-faq-navigation__item--active');
    }
  }

  initMobileScroll() {
    if (!this.nav || !this.progressBar) return;

    const updateProgress = () => {
      const scrollLeft = this.nav.scrollLeft;
      const scrollWidth = this.nav.scrollWidth;
      const clientWidth = this.nav.clientWidth;
      const maxScroll = scrollWidth - clientWidth;

      // Calcule le ratio de contenu visible
      const visibleRatio = clientWidth / scrollWidth;
      const thumbWidth = visibleRatio * 100;

      // Calcule la position du scroll (0 à 1)
      const progress = maxScroll > 0 ? scrollLeft / maxScroll : 0;

      // Positionne le thumb
      const scrollableWidth = 100 - thumbWidth;
      const thumbLeft = progress * scrollableWidth;

      this.progressBar.style.width = `${thumbWidth}%`;
      this.progressBar.style.left = `${thumbLeft}%`;
    };

    // Met à jour au scroll
    this.nav.addEventListener('scroll', updateProgress);

    // Met à jour au chargement et au resize
    updateProgress();
    window.addEventListener('resize', updateProgress);
  }

  initIntersectionObserver() {
    const options = {
      root: null,
      rootMargin: '-20% 0px -70% 0px',
      threshold: 0
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          const categoryId = entry.target.getAttribute('data-category-id');
          const correspondingNavItem = this.section.querySelector(
            `.section-faq-navigation__nav-item[data-category-id="${categoryId}"]`
          );

          if (correspondingNavItem) {
            this.navItems.forEach((item) => {
              item.classList.remove('section-faq-navigation__nav-item--active');
            });
            correspondingNavItem.classList.add('section-faq-navigation__nav-item--active');

            // Scroll nav item into view on mobile
            if (window.innerWidth < 990 && this.nav) {
              const navItemLeft = correspondingNavItem.offsetLeft;
              const navItemWidth = correspondingNavItem.offsetWidth;
              const navWidth = this.nav.offsetWidth;
              const scrollPosition = navItemLeft - (navWidth / 2) + (navItemWidth / 2);

              this.nav.scrollTo({
                left: scrollPosition,
                behavior: 'smooth'
              });
            }
          }
        }
      });
    }, options);

    this.categories.forEach((category) => {
      observer.observe(category);
    });
  }
}

// Initialize all FAQ Navigation sections
document.addEventListener('DOMContentLoaded', () => {
  const faqSections = document.querySelectorAll('[data-section-type="faq-navigation"]');
  faqSections.forEach((section) => {
    new FAQNavigation(section);
  });
});

// Shopify theme editor support
if (typeof Shopify !== 'undefined' && Shopify.designMode) {
  document.addEventListener('shopify:section:load', (event) => {
    const section = event.target.querySelector('[data-section-type="faq-navigation"]');
    if (section) {
      new FAQNavigation(section);
    }
  });
}
